module.exports = __webpack_public_path__ + "img/imgNo.2054415d.png";